import { Errors } from '@/models/enums';

export function getCancelledError(): Error {
  return new Error(Errors.Cancelled);
}
export function throwCancelled(): void {
  throw getCancelledError();
}

const cancelledRegExp = new RegExp(Errors.Cancelled, 'i');
export function isCancelledError(error: any): boolean {
  return !!error && cancelledRegExp.test(error);
}
